export { default } from "./AdminConsoleSchoolsDirectoryPage";
